// extracted by mini-css-extract-plugin
module.exports = {"svg":"cloud-two_svg__QHHR3"};